const KnowledgeQuickLinks = () => {
  const quickLinksElement = document.querySelector('.knowledge-quick-links--sticky');

  let isTopClassAdded = false; // Track if the class is already added to avoid redundant operations

  const handleScroll = () => {
    // Get the bounding rectangle of the element
    const rect = quickLinksElement.getBoundingClientRect();
    
    // If the top of the element is at or below the top of the viewport, add the class
    if (rect.top <= 0 && !isTopClassAdded) {
      quickLinksElement.classList.add('knowledge-quick-links--top');
      isTopClassAdded = true; // Track that the class is added
    } else if (rect.top > 0 && isTopClassAdded) {
      quickLinksElement.classList.remove('knowledge-quick-links--top');
      isTopClassAdded = false; // Track that the class is removed
    }
  };

  // Use requestAnimationFrame to optimize the scroll event handling
  const optimizedScrollHandler = () => {
    requestAnimationFrame(handleScroll);
  };

  // Attach the scroll event listener
  window.addEventListener('scroll', optimizedScrollHandler);

  // Call once to check initial position in case the page is loaded with the div already at the top
  handleScroll();

  // calculate offset
  document.getElementById("quick-links").addEventListener("change", function() {
    const targetId = this.value;
    if (targetId.startsWith("#")) {
        const target = document.querySelector(targetId);
        if (target) {
            const offset = 150; // Adjust as needed
            const targetPosition = target.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
                top: targetPosition - offset,
                behavior: "smooth"
            });
        }
    }
  });
};

export default KnowledgeQuickLinks;
